export default "__VITE_ASSET__d1288a69__"